var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmDebitBlackWhite = function SvgPmDebitBlackWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.889 6.75H32.11c.65 0 1.139.506 1.139 1.083V20c0 2.35-.702 4.141-1.905 5.345C30.14 26.548 28.35 27.25 26 27.25H1.889c-.65 0-1.139-.506-1.139-1.083V7.833c0-.577.489-1.083 1.139-1.083Z",
    stroke: "#08031D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.982 20.667c.654 0 1.185-.597 1.185-1.334 0-.736-.531-1.333-1.186-1.333H15.5v2.667m1.482 0H15.5m1.482 0c.654 0 1.185.597 1.185 1.333s-.531 1.333-1.186 1.333H15.5v-2.666M13 18h-2.5v2.667m2.5 2.666h-2.5v-2.666m0 0h2M20.722 18v5.333m2-5.333H24.5m0 0h1.778M24.5 18v5.333M22 11h6M6.814 18C7.47 18 8 18.597 8 19.333V22c0 .736-.53 1.333-1.186 1.333H5V18h1.814ZM5 11.5V13a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1Z",
    stroke: "#08031D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPmDebitBlackWhite;